<template>
  <div class="report-statuses-page">
    <div class="container">
      <!-- <div class="table-filter-container">
        <select
          v-model="filter.reportCompanyValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Выберите компанию</option>
          <option
            v-for="company in this.allCompany"
            :key="company"
            :value="company"
          >
            {{ company }}
          </option>
        </select>
        <select
          v-model="filter.reportYearValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Выберите год</option>
          <option v-for="year in this.allYear" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <select
          v-model="filter.reportMonthValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Выберите месяц</option>
          <option v-for="month in this.allMonth" :key="month" :value="month">
            {{ month | getMonth }}
          </option>
        </select>
        <select
          v-model="filter.reportStatusValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Статус</option>
          <option
            v-for="status in this.allStatus"
            :key="status"
            :value="status"
          >
            {{ status }}
          </option>
        </select>
        <button class="table-filter-submit" @click="changeReportsFilter()">
          <i class="fas fa-search fa-menu"></i>
          Поиск
        </button>
      </div> -->
      <!-- <div class="report-actions">
        <form v-if="isRecipient" @submit.prevent="downloadExcelMonth">
          <select class="download-select" required v-model="select_month">
            <option value>Выберите месяц</option>
            <option
              v-for="month in this.months"
              :key="month.name"
              :value="month.value"
            >
              {{ month.name }}
            </option>
          </select>
          <button type="submit" class="download-btn">Загрузить в excel</button>
        </form>
      </div> -->
      <div class="table-container">
        <div class="card-main">
          <h2>Наименование ДЗО</h2>
          <table class="table">
            <thead>
              <tr>
                <th>Отчет</th>
                <th>Статус</th>
                <th>Создан</th>
                <th>Утвержден</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Отчет за Август 2021 "Астана"</td>
                <td><span class="status-info gray-status">Создан</span></td>
                <td>
                  <ul style="list-style-type: none">
                      <li>
                          Саматов Самат
                      </li>
                  </ul>
                </td>
                <td>

                </td>
              </tr>
              <tr>
                <td>Отчет за Сентябрь 2021 "Астана"</td>
                <td><span class="status-info yellow-status">Сформирован</span></td>
                <td>
                  <ul style="list-style-type: none">
                      <li>
                          Саматов Самат
                      </li>
                  </ul>
                </td>
                <td>
                    <ol>
                      <li>
                          Бериков Берик
                      </li>
                      <li>
                          Сериков Серик
                      </li>
                  </ol>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card-main">
          <h2>Наименование ДЗО 2</h2>
          <table class="table">
            <thead>
              <tr>
                <th>Отчет</th>
                <th>Статус</th>
                <th>Создан</th>
                <th>Утвержден</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Отчет за Август 2021 "Астана"</td>
                <td><span class="status-info gray-status">Создан</span></td>
                <td>
                  <ul style="list-style-type: none">
                      <li>
                          Саматов Самат
                      </li>
                  </ul>
                </td>
                <td>
                    
                </td>
              </tr>
              <tr>
                <td>Отчет за Сентябрь 2021 "Астана"</td>
                <td><span class="status-info green-status">Утвержден</span></td>
                <td>
                  <ul style="list-style-type: none">
                      <li>
                          Саматов Самат
                      </li>
                  </ul>
                </td>
                <td>
                    <ol>
                      <li>
                          Бериков Берик
                      </li>
                      <li>
                          Сериков Серик
                      </li>
                  </ol>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <table>
          <thead>
          <tr>
            <th>№ п/п</th>
            <th>ДЗО</th>
            <th>Отчет создан</th>
            <th>Отчет утвержден</th>
            <th>Год</th>
            <th>Месяц</th>
            <th>Дата создания</th>
            <th>Статус</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(report, index) in this.reports"
              :key="report.id"
              @click="openReport(report.id)"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ report.dzo.name }}</td>
            <td>
              {{ report.create_user.first_name | TitleCase }}
              {{ report.create_user.last_name | TitleCase }}
            </td>
            <td>
              {{ report.approved_user ? report.approved_user.first_name : '' | TitleCase }}
              {{ report.approved_user ? report.approved_user.last_name : '-' | TitleCase}}
            </td>
            <td>{{ report.year }}</td>
            <td>{{ report.month | getMonth }}</td>
            <td>{{ report.created_datetime | formatDate }}</td>
            <td>
              <p class="my-report-status" :class="getBtnColor(report.status)">
                {{ report.status }}
              </p>
            </td>
          </tr>
          </tbody>
        </table> -->
      </div>
      <!--      <button v-if="isImpl" class="delete-reports-btn" @click="deleteAllReport()">Удалить все отчеты кроме-->
      <!--          первого-->
      <!--      </button>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isImpl, isRecipient, isApproved } from "@/variables";
import { month_options } from "@/variables";

export default {
  components: {},
  data() {
    return {
      isImpl: false,
      isRecipient: false,
      isApproved: false,
      select_month: "",
      reports: [],
      allReports: [],
      months: "",
      allCompany: "",
      allYear: "",
      allMonth: "",
      allStatus: "",
      filter: {
        reportCompanyValue: "",
        reportStatusValue: "",
        reportYearValue: "",
        reportMonthValue: "",
      },
    };
  },
  created() {
    this.months = month_options;
  },
  methods: {
    downloadExcelMonth() {
      let formData = {
        reportId: this.$route.params.id,
        month: this.select_month,
      };
      this.$store.dispatch("downLoadExcel", formData);
    },
    getAllReports() {
      this.$store.dispatch("getAllReports").then((response) => {
        this.reports = response;
        this.allReports = response;
        this.initializeSet(response);
      });
      this.$store.dispatch("addNotification", {
        type: "success",
        message: "Мои отчеты обновлены",
      });
    },
    openReport(id) {
      this.$router.push({ name: "view-report-item", params: { id: id } });
    },
    // deleteAllReport() {
    //   this.$store.dispatch('deleteAllReport');
    // },
    getBtnColor(status) {
      let color = "";
      if (status === "Создан") {
        color = "status-green";
      } else if (status === "Подписан исполнителем") {
        color = "status-yellow";
      } else if (status === "Подписан утверждающим") {
        color = "status-yellow";
      } else if (status === "Редактирован") {
        color = "status-yellow";
      } else if (status === "Авто-изменения после корректировки") {
        color = "status-yellow";
      } else if (status === "Утвержден получателем КМГ") {
        color = "status-blue";
      } else if (status === "Отклонен утверждающим") {
        color = "status-red";
      } else if (status === "Отклонен получателем КМГ") {
        color = "status-red";
      }
      return color;
    },
    initializeSet(reports) {
      var mySetCompany = new Set();
      var mySetStatus = new Set();
      var mySetYear = new Set();
      var mySetMonth = new Set();
      for (let i = 0; i < reports.length; ++i) {
        mySetCompany.add(reports[i].dzo.name);
        mySetStatus.add(reports[i].status);
        mySetYear.add(reports[i].year);
        mySetMonth.add(reports[i].month);
      }
      this.allCompany = mySetCompany;
      this.allStatus = mySetStatus;
      this.allYear = mySetYear;
      this.allMonth = mySetMonth;
    },
    changeReportsFilter() {
      var status = this.filter.reportStatusValue;
      var company = this.filter.reportCompanyValue;
      var year = this.filter.reportYearValue;
      var month = this.filter.reportMonthValue;
      if (company || status || month || year) {
        this.reports = this.allReports.filter(function (report) {
          return (
            (status ? report.status === status : true) &&
            (company ? report.dzo.name === company : true) &&
            (month ? report.month === month : true) &&
            (year ? report.year === year : true)
          );
        });
      } else {
        this.reports = this.allReports;
      }
    },
  },

  mounted() {
    this.getAllReports();
    this.isImpl = isImpl(this.USER.ouser);
    this.isRecipient = isRecipient(this.USER.ouser);
    this.isApproved = isApproved(this.USER.ouser);
  },
  computed: {
    ...mapGetters(["REPORTS", "ALLDZO", "USER"]),
  },
};
</script>

<style scoped>
.report-statuses-page {
  background: #f0f4f5;
  min-height: 100vh;
}

.container {
  padding-top: 3rem;
  padding-bottom: 1rem;
}

.card-main {
  /* min-width: 115rem; */
  background-color: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 0 10px 2px rgba(76, 94, 114, 0.03);
  padding: 3rem 3rem 2.5rem 3rem;
  margin-bottom: 3rem;
}

.table {
  border-collapse: collapse;
  margin-top: 1.6rem;
  width: 100%;
}
.table thead tr {
  height: 4rem;
}
.table th {
  background-color: #eef5f7;
  text-align: left;
}
.table th:first-child {
  -moz-border-radius: 6px 0 0 6px;
  padding-left: 2rem;
  border-radius: 6px 0 0 6px;
}
.table th:last-child {
  -moz-border-radius: 0 6px 6px 0;
  border-radius: 0 6px 6px 0;
  padding-right: 2rem;
}
.table th img {
  vertical-align: 20%;
  padding-left: 4px;
  cursor: pointer;
}
.table td {
  cursor: pointer;
}
.table td:first-child {
  padding-left: 2rem;
}
.table td:last-child {
  padding-right: 2rem;
}
.table tbody img {
  transform: rotate(45deg);
}
.table tbody tr {
  height: 5.2rem;
  border-bottom: 1px solid #e3e7eb;
}
.table tbody tr:last-child {
  border-bottom: none;
}
.table tbody tr:hover {
  background-color: #f9fbfb;
}
.status-info {
    color: white;
    padding: .5rem 1rem;
    border-radius: 5px;
    margin: 0 auto;
}

.green-status {
    background: #307351;
}

.yellow-status {
    background: #FEC601;
}

.gray-status {
    background: gray;
}
</style>
